import { BuildingStatus } from '../../core-models';

export type BuildingStatusName = (typeof BuildingStatusName)[BuildingStatus];

export const BuildingStatusName = {
    [BuildingStatus.Draft]: 'Draft',
    [BuildingStatus.Published]: 'Published',
} as const;

export function getBuildingStatusName(
    buildingStatus: BuildingStatus
): BuildingStatusName {
    return BuildingStatusName[buildingStatus];
}

export function getBuildingStatus(
    buildingStatusName: BuildingStatusName
): BuildingStatus {
    for (const key in BuildingStatusName) {
        if (
            BuildingStatusName[key as unknown as BuildingStatus] ===
            buildingStatusName
        ) {
            return Number(key) as BuildingStatus;
        }
    }
    throw new TypeError(
        `No BuildingStatus found for name: ${buildingStatusName}`
    );
}

export function isBuildingStatusName(
    statusName: string
): statusName is BuildingStatusName {
    return (Object.values(BuildingStatusName) as string[]).includes(statusName);
}
